export default {
   appConfig: {},
}


// WEBPACK FOOTER //
// ./src/store/state.js